import React from 'react';

import QuotaWinterZonals  from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaZonals/List.js';

export default function () {
  return <QuotaWinterZonals  />;
}
